export default "__VITE_ASSET__Dqz7ubbK__"